export default () => ({
  newTag: '',
  innerTags: this.professionalTags,
  isInputActive: false
})



// WEBPACK FOOTER //
// ./src/app/professional/company/companies/components/tags/resources/data.js